<nb-card class="dialog" [nbSpinner]="uploadingData" [ngClass]="{'d-none': isCreatingDataSourceForDashboard}">
  <nb-card-header class="header">
    <morva-icons
      class="close-cross"
      icon="close"
      (click)="close()">
		</morva-icons>
    <p data-testid="create-dashboard-header-text" class="header-text">ورود یا انتخاب داده</p>
  </nb-card-header>

  <nb-card-body class="body">
    <div class="connectors-dataInput">

      <div class="connectors">
        <div class="connectors-title">اتصال</div>
        <div class="connectors-box">
          <div class="d-flex flex-column justify-content-between">
            <span (click)="openDataBaseCreateDialog('CreateSqlServer')">Microsoft SQL Server</span>
            <span (click)="openWebServiceDialog()">Webservice</span>
            <span (click)="openDataBaseCreateDialog('CreateOracle')">Oracle</span>
          </div>
          <div class="d-flex flex-column justify-content-between">
            <span class="disable">MySQL</span>
            <span class="disable">SQL Server Analysis Services Database</span>
            <span class="disable">Google Analytics</span>
          </div>
        </div>
      </div>


      <section class="uploads">
        <div class="title">فایل</div>
        <div 
					data-testid="data-input-box" 
					class="data-input-box" 
					dragOverClass="drag-over" 
					droppable 
					(filesDropped)="onFileDrop($event)"
          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,.csv,application/json">
            <span>دادها را در اﯾﻦ ﻗﺴﻤﺖ بکشید و رها ﮐﻨﯿﺪ ﯾﺎ از داﺧﻞ ﺳﯿﺴﺘﻢ ﺧﻮد بارگذاری کنید.</span>
            <p>فایل‌های csv و Excel Microsoft پشتیبانی می‌شود.</p>
        </div>

        <div class="data-input-url">
          <p>افزودن URL</p>
          <form (submit)="uploadFileFromURL(inputValue)">
            <input
              [(ngModel)]="inputValue"
              name="urlInput"
              type="url"
              placeholder="فایل‌های csv و Excel Microsoft پشتیبانی می‌شود.">
            <button nbButton type="submit" [disabled]="inputValue === ''">بارگذاری</button>
          </form>
        </div>
      </section>
    </div>

    <ng-container>
      <div class="datasources">
        <div class="title">
          <p>یکی از منابع داده زیر را انتخاب کنید.</p>
          <div class="left-side">

            <div *ngIf="!noData" class="order">
              <span> نمایش براساس: </span>
              <button
                mat-button
                [matMenuTriggerFor]="sort"
                (click)="showSort()">
                <morva-icons icon="descending" class="icon-18"></morva-icons>
                <p>{{ selectedSort }}</p>
                <morva-icons
                  *ngIf="!isDroppedSortTypesDropdown"
                  icon="caretDownOutline"
                  class="me-auto icon-18">
								</morva-icons>
                <morva-icons
                  *ngIf="isDroppedSortTypesDropdown"
                  icon="caretUpOutline"
                  class="me-auto icon-18">
								</morva-icons>
              </button>
              <mat-menu #sort="matMenu" class="sort-dropdown mat-elevation-z4">
                <button
                  mat-menu-item
                  *ngFor="let sortItem of sortItems"
                  (click)="changeSort(sortItem)"
                  [id]="sortItem.id">
                  {{ sortItem?.name }}
                </button>
              </mat-menu>
            </div>

            <morva-sort-button 
              [loading]="loadingDataSources"
              [ascending]="dataSourcesLoading.ascending"
              (sortChange)="onSortDirectionChange($event)">
            </morva-sort-button>

            <div class="search-box">
              <input
                #dataSourceFilter
                class="search-input"
                type="text"
                nbInput
                fullWidth
                fieldSize="tiny"
                placeholder="جستجو">
              <morva-icons icon="search" class="icon-16"></morva-icons>
            </div>
          </div>
        </div>

        <div class="table" *ngIf="!loadingDataSources && !noData">
          <nb-card>
            <nb-card-body>
              <div class="header">
                <p class="name col-4">نام</p>
                <p class="type col-2">حجم داده</p>
                <p class="col-1">تعداد رکورد</p>
                <p class="col-2">مالک</p>
                <p class="col-2">زمان به‌روز‌رسانی</p>
                <p class="col-1">بازدید</p>
              </div>
              <hr>
              <div *ngFor="let dataSource of dataSources" class="table-row">
                <div 
									class="table-row-content"
                  (click)="addToDashboard ? addDataSourceToDashboard(dataSource) :makeNewDashboard(dataSource)">
                    <p class="name col-4">
											<ng-container [ngSwitch]="dataSource.dbConnectionType">
												<morva-icons *ngSwitchCase="'MicrosoftSQLServer'" class="item-icon" icon="sqlListAsset"></morva-icons>
												<morva-icons *ngSwitchCase="'File'" class="item-icon" icon="excelListAsset"></morva-icons>
												<morva-icons *ngSwitchCase="'URL'" class="item-icon" icon="excelListAsset"></morva-icons>
												<morva-icons *ngSwitchCase="'Oracle'" class="item-icon" icon="oracleListAsset"></morva-icons>
												<morva-icons *ngSwitchCase="'WebService'" class="item-icon" icon="webserviceListAsset"></morva-icons>
											</ng-container>
                      {{ dataSource.name }}
                    </p>
                    <p class="type col-2 table-row-size">
                      {{ dataSource.size | dataSize }}
                    </p>
                    <p class="col-1">
											{{ dataSource.rowNumber }}
										</p>
                    <p class="col-2">
                      {{ dataSource.ownerFirstName }}
                      {{ dataSource.ownerLastName }}
                    </p>
                    <p class="col-2" *ngIf="dataSource.updateTickTime !== 0">
                      {{ dataSource.updateTickTime | ticksToDate }}
                    </p>
                    <p class="col-2" *ngIf="dataSource.updateTickTime === 0">
                      -
                    </p>
                    <p class="col-1 view">
											{{ dataSource.view }}
										</p>
                </div>
              </div>
            </nb-card-body>
          </nb-card>
        </div>

        <div class="footer" *ngIf="totalPages && !loadingDataSources">
          <morva-pagination
            *ngIf="totalPages > 1"
            [totalPage]="totalPages"
            [selectedPage]="pageNumber"
            (pageChange)="setPageNumber($event)">
					</morva-pagination>
        </div>
      </div>
      <div class="not-datasources" [nbSpinner]="loadingDataSources">
        <div class="content" *ngIf="noData && !loadingDataSources && !isSearching">
          <img src="/assets/images/no-datasources.png" alt="no-dataSource">
            <p class="content-text">
               منبع‌داده‌ای در فضای‌کاری یافت نشد.
            </p>
            <p class="content-text">
               منبع‌داده خود را بارگذاری کنید.
            </p>
        </div>
      </div>
      <div 
				class="mx-auto p-5 d-flex justify-content-center align-items-center flex-column"
        *ngIf="noData && isSearching">
          <div class="no-data">
            <img src="/assets/images/not-found-result.png" alt="نتیجه‌ای یافت نشد.">
          </div>
          <div class="no-data-text">
            <p>نتیجه‌ای یافت نشد.</p>
          </div>
      </div>
    </ng-container>
  </nb-card-body>
</nb-card>
